import React from 'react';
import { Routes, Route } from 'react-router-dom';

import MainRoutes from 'app/routes/MainRoutes';

/**
 * This component describes application routes.
 *
 * @function   AppRoutes
 */
function AppRoutes() {
  return (
    <Routes>
      <Route path="/*" element={<MainRoutes />} />
    </Routes>
  );
}

export default AppRoutes;
